import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/indents/$indentId")({
  component: () => <Outlet />,
});
